import React from "react"
import ReactDOM from "react-dom/client"
import "./index.css"
import { HashRouter as Router } from "react-router-dom"
import App from "./App";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <React.StrictMode>
        <Router>
            <App/>
        </Router>
    </React.StrictMode>
)
